// extracted by mini-css-extract-plugin
module.exports = {"title":"block_title_31z5N","backgroundColor":"block_backgroundColor_374oq"};